import { createContext } from "react";

const HarvestContext = createContext();
export { HarvestContext };

const HarvestUIContext = createContext({
  selectedDay: "ALL",
  setSelectedDay: () => {},
  isForecastAvailable: true,
  setIsForecastAvailable: () => {},
  activeWeek: "current",
  setActiveWeek: () => {},
  setWeekTotal: () => {},
  preserveTotalCardRef: { current: false },
  yieldUnit: "ton",
  setYieldUnit: () => {},
  kgPerBin: null,
  areaUnit: "Hectare", // 'Hectare' or 'acre'
  setAreaUnit: () => {},
});

export { HarvestUIContext };

